import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Main from './component/MainComponent'
//import './App.css';

function App() {
  return (
    <div className="App">
      <Main/>
      
    </div>
  );
}

export default App;
